import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'HELP_ICON';

export const {
    action: fetchHelp,
    success: fetchHelpSuccess,
    failed: fetchHelpFailed,
    aborted: fetchHelpAborted,
} = createAction(`${domain}/FETCH_HELP`, (helpKey, showModalOnSuccess) => ({helpKey, showModalOnSuccess}));
